import Breadcrumb from "../components/Breadcrumb";
import UsersList from "../components/UsersList";

const UsersListPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Users" />

      {/* users list page */}
      <UsersList />
    </>
  );
};

export default UsersListPage;
